import React from 'react';
import ReserveFieldUsers from '@/components/reserve/ReserveFieldUsers/ReserveFieldUsers';
import { useReserveForm } from '@/components/reserve/Reserve/ReserveFormProvider';
import { useAuthenticated } from '@gettactic/hooks';

export const ReserveFormMeetingRoomUsersSelector: React.FC = () => {
  const {
    userContext: { authenticatedUser }
  } = useAuthenticated();

  const { form } = useReserveForm();
  return (
    <ReserveFieldUsers
      form={form}
      single={false}
      defaultValue={[]}
      filterValues={(option) => option.value !== authenticatedUser?.user?.id}
      errors={form.formState.errors}
    />
  );
};
